module.exports = __webpack_public_path__ + "static/media/ReactIcon.1dfbff3a.svg";